export const workspaceDestinations = [
  { path: '/home', label: '总览' },
  { path: '/notes', label: '笔记' },
  { path: '/courses', label: '课程' },
  { path: '/calendar', label: '学习日历' },
  { path: '/plan', label: '计划' },
] as const;

export function workspaceHref(path: string, preview: boolean) {
  if (!preview) return path;
  const url = new URL(path, 'https://workspace.invalid');
  url.searchParams.set('ui-preview', '');
  return `${url.pathname}${url.search}${url.hash}`;
}

export function workspaceTitle(path: string) {
  if (path === '/agent') return 'Agent 学习助手';
  if (path.startsWith('/classroom/')) return '课堂';
  if (path === '/academics') return '学校信息';
  if (path === '/profile') return '账号与设置';
  return workspaceDestinations.find(item => item.path === path)?.label || '学习空间';
}
